var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.35,
    stroke: "#364A5E",
    strokeWidth: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4939 16.2713V19.0057C26.4939 19.4569 26.1248 19.826 25.6736 19.826H17.7439V24.4061C17.7439 25.1376 16.8621 25.4999 16.3425 24.9872L9.57495 18.2196C9.25366 17.8983 9.25366 17.3788 9.57495 17.0575L16.3425 10.2899C16.8621 9.77036 17.7439 10.1395 17.7439 10.871V15.451H25.6736C26.1248 15.451 26.4939 15.8202 26.4939 16.2713Z",
    fill: "#364A5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/backIcon.c5614c40d25d8eb6ef55251c9e33b398.svg";
export { ForwardRef as ReactComponent };